import type {ReactNode} from 'react';
import React, {useEffect, useState} from 'react';
import MarkdownRenderer from '@Components/ai-chat-window/components/markdown-renderer/markdown-renderer';
import {AiThreeDotsLoader} from '@Components/ai-chat-window/components/ai-three-dots-loader/ai-three-dots-loader';
import type {CyclingLoadingTextProps} from './cycling-loading-text.types';
import styles from './cycling-loading-text.module.scss';

export function CyclingLoadingText({loadingTexts}: CyclingLoadingTextProps): ReactNode {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeToNextLoadingTextMs = 4000;

  useEffect(() => {
    if (currentIndex >= loadingTexts.length - 1) {
      return;
    }

    const timer = setTimeout(() => {
      setCurrentIndex((prev) => Math.min(prev + 1, loadingTexts.length - 1));
    }, timeToNextLoadingTextMs);

    return (): void => {
      clearTimeout(timer);
    };
  }, [currentIndex, loadingTexts.length]);

  return (
    <div className={`${styles.container} flex-v-center`}>
      <MarkdownRenderer content={loadingTexts[currentIndex]} suffix={<AiThreeDotsLoader className={'spacing-m-l-1'} />} />
    </div>
  );
}
